import LegalLayout from "@/components/LegalLayout";

export default function Impressum() {
  return (
    <LegalLayout title="Impressum">
      <p>
        <strong>AutoGlas Erol GmbH</strong>
      </p>
      <p>
        Frankenthaler Str. 98<br />
        67059 Ludwigshafen<br />
        Deutschland
      </p>
      <p>
        Tel.: +49 621 527429<br />
        E-Mail: <a href="mailto:info@billigautoglas.de">info@billigautoglas.de</a>
      </p>
      <p>
        <strong>Öffnungszeiten Werkstatt:</strong><br />
        Mo–Fr 09:00–18:00 Uhr<br />
        Sa 09:00–14:00 Uhr
      </p>
      <p>
        <strong>Registergericht:</strong> Amtsgericht Mannheim<br />
        <strong>Registernummer:</strong> HRB 708423
      </p>
      <p>
        <strong>USt-IdNr.:</strong> DE308408055<br />
        <strong>Steuernummer:</strong> 3700702607
      </p>
      <p>
        <strong>Geschäftsführerin:</strong> Fatma Caglayan
      </p>
      <p>
        <strong>Verbraucherstreitbeilegung (§ 36 VSBG):</strong><br />
        Wir sind zur Teilnahme an einem Streitbeilegungsverfahren vor einer Verbraucherschlichtungsstelle
        weder verpflichtet noch bereit.
      </p>
      <p>
        <strong>Verantwortlich für den Inhalt dieser Website:</strong> AutoGlas Erol GmbH, Anschrift wie oben.
      </p>
    </LegalLayout>
  );
}
